
import React, { useEffect } from 'react';

const JobsPageCustomizer = () => {
  useEffect(() => {
    // Function to inject custom CSS into iframe (if same-origin)
    const customizeJobsPage = () => {
      const iframe = document.querySelector('iframe[title="Trbe Careers"]');
      if (iframe) {
        try {
          // Note: This will only work if the embedded page allows it (same-origin or proper CORS headers)
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          
          if (iframeDoc) {
            // Create custom CSS for brand colors
            const customCSS = `
              <style>
                /* Trbe Brand Color Overrides */
                :root {
                  --primary-color: #251434;
                  --secondary-color: #143A5D;
                  --accent-color: #EC681C;
                  --light-blue: #5E93AB;
                  --rose: #B48B90;
                }
                
                /* Header and navigation */
                .header, .navbar, .nav-header {
                  background-color: var(--primary-color) !important;
                  color: white !important;
                }
                
                /* Primary buttons */
                .btn-primary, .button-primary, .primary-button {
                  background-color: var(--accent-color) !important;
                  border-color: var(--accent-color) !important;
                }
                
                .btn-primary:hover, .button-primary:hover, .primary-button:hover {
                  background-color: #d55a16 !important;
                  border-color: #d55a16 !important;
                }
                
                /* Secondary buttons */
                .btn-secondary, .button-secondary, .secondary-button {
                  background-color: var(--secondary-color) !important;
                  border-color: var(--secondary-color) !important;
                }
                
                /* Links */
                a, .link {
                  color: var(--secondary-color) !important;
                }
                
                a:hover, .link:hover {
                  color: var(--accent-color) !important;
                }
                
                /* Job cards and listings */
                .job-card, .position-card, .listing-card {
                  border-left: 4px solid var(--accent-color) !important;
                }
                
                /* Job titles */
                .job-title, .position-title, h1, h2, h3 {
                  color: var(--primary-color) !important;
                }
                
                /* Apply buttons */
                .apply-button, .btn-apply, [class*="apply"] button {
                  background-color: var(--accent-color) !important;
                  color: white !important;
                  border: none !important;
                }
                
                .apply-button:hover, .btn-apply:hover, [class*="apply"] button:hover {
                  background-color: #d55a16 !important;
                }
                
                /* Form elements */
                .form-control:focus, input:focus, textarea:focus, select:focus {
                  border-color: var(--light-blue) !important;
                  box-shadow: 0 0 0 0.2rem rgba(94, 147, 171, 0.25) !important;
                }
                
                /* Progress indicators */
                .progress-bar, .step-indicator.active {
                  background-color: var(--accent-color) !important;
                }
                
                /* Tags and badges */
                .badge, .tag, .chip {
                  background-color: var(--light-blue) !important;
                  color: white !important;
                }
                
                /* Footer */
                .footer {
                  background-color: var(--primary-color) !important;
                  color: var(--light-blue) !important;
                }
              </style>
            `;
            
            // Inject the CSS
            const head = iframeDoc.head || iframeDoc.getElementsByTagName('head')[0];
            if (head && !head.querySelector('#trbe-custom-styles')) {
              const style = iframeDoc.createElement('div');
              style.id = 'trbe-custom-styles';
              style.innerHTML = customCSS;
              head.appendChild(style);
            }
          }
        } catch (error) {
          console.log('Cannot customize external page due to CORS restrictions:', error.message);
          // This is expected for cross-origin iframes
        }
      }
    };

    // Try to customize after iframe loads
    setTimeout(customizeJobsPage, 2000);
    
    // Also try when iframe loads
    const iframe = document.querySelector('iframe[title="Trbe Careers"]');
    if (iframe) {
      iframe.addEventListener('load', customizeJobsPage);
    }
    
    return () => {
      if (iframe) {
        iframe.removeEventListener('load', customizeJobsPage);
      }
    };
  }, []);

  return null; // This component doesn't render anything
};

export default JobsPageCustomizer;
